<template>

	<div class="wrapper">
		<div class="section section-blogs-2 topsearch">
			<div class="container main">
				<div class="md-layout">
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">
						<router-link :to="{ name: 'DictionaryList', params: {dictionaryId: dictCode, page: page} }"
									 id="buttonback">
							<md-icon>keyboard_arrow_left</md-icon>
							Назад к списку справочников
						</router-link>
					</div>
					<div class="md-layout-item md-size-100 md-small-size-100 mx-auto">

						<div class="name">
							<h3 class="title">Редактирование элемента справочника FAQ</h3>
							<div class="md-layout-item md-size-100 md-xsmall-size-100 fieldsep" v-if="selectedDataId">


								<div class="md-layout-item md-size-100 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('question')">
										<label>{{mapElementName['question']}}</label>
										<md-input type="text" v-if="action === 'delete'"
												  v-model="form['question']"></md-input>
										<md-input type="text" v-else v-model="form['question']"></md-input>
										<span class="md-error" v-if="!$v.form.question.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div class="md-layout-item md-size-100 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('answer')">
										<label>{{mapElementName['answer']}}</label>
										<md-textarea readonly type="text" v-if="action === 'delete'"
													 v-model.number="form['answer']"></md-textarea>
										<md-textarea type="text" v-else v-model.number="form['answer']"></md-textarea>
										<span class="md-error" v-if="!$v.form.answer.required">Обязательно для заполнения</span>
									</md-field>
								</div>

								<div class="md-layout-item md-size-40 md-xsmall-size-100 text-center fieldsep">
									<md-field :class="getValidationClass('order')">
										<label>{{mapElementName['order']}}</label>
										<md-input type="number"
												  v-model.number="form['order']"></md-input>
										<span class="md-error"
											  v-if="!$v.form.order.required">Обязательно для заполнения</span>
									</md-field>
								</div>
							</div>
							<br/>
							<div class="md-layout-item md-gutter md-size-100 md-xsmall-size-100 fieldsep">

								<template v-if="selectedDataId">
									<md-button @click="validateData(saveItem)"
											   class="md-button md-success md-theme-default"
											   v-if="action !== 'delete'">
										Сохранить
									</md-button>

									<md-button @click="validateData(deleteItem)"
											   class="md-button md-primary  md-theme-default"
											   v-if="action === 'delete'">
										Удалить
									</md-button>

								</template>
							</div>
						</div>


					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
    import {
        required,
    } from 'vuelidate/lib/validators'
    import { saveItem, getItem, deleteItem } from '@/utils/dict-api'

    export default {
        mixins: [
            validationMixin,
        ],
        bodyClass: 'dictionary-data',
        props: ['page', 'action'],
        data () {
            return {
                options: [],
                dictCode: this.$route.params.dictCode,
                dictionaryId: '',
                selectedDataId: this.$route.params.id,
                selectedData: null,
                form: {
                    action: 'save',
                    question: '',
                    order: 1,
                    answer: '',
                },
                mapElementName: {
                    'order': 'Порядок отображения',
                    'question': 'Вопрос',
                    'answer': 'Ответ',
                },
            }
        },
        validations: {
            form: {
                question: {
                    required,
                },
                order: {
                    required,
                },
                answer: {
                    required,
                },
            },
        },
        methods: {
            getValidationClass (fieldName) {
                const field = this.$v.form[fieldName]
                if (field) {
                    return {
                        'md-invalid': field.$invalid && field.$dirty,
                    }
                }
            },
            validateData (sendFn) {
                this.$v.form.$touch()
                if (!this.$v.form.$invalid) {
                    sendFn()
                }
            },
            setData: function (data) {
                this.form = data
            },
            getElementData: function () {
                if (this.selectedDataId === 'new') {
                    this.addItem()
                    return
                }
                checkAuthentication(this.$router, this.$route)
                  .then(() => {
                      getItem('faq', this.selectedDataId)
                        .then(result => {
                            this.setData(result)
                        })
                        .catch(error => {
                            reAuthenticate(this.$router, this.$route, error)
                        })
                  })
            },
            addItem: function () {
                const item = {
                    'id': null,
                    'question': '',
                    'answer': '',
                    'order': '',
                }
                this.setData(item)
            },
            deleteItem: function () {
                checkAuthentication(this.$router, this.$route)
                  .then(() => {
                      deleteItem(this.$route.params.dictCode, JSON.stringify({ id: this.$route.params.id }))
                        .then(() => {
                            this.$router.push({
                                name: 'DictionaryList',
                                params: { dictionaryId: this.dictCode, page: this.page },
                            })
                        })
                        .catch(error => {
                            reAuthenticate(this.$router, this.$route, error)
                        })
                  })
            },
            saveItem: function () {
                if (this.form.id === 'new') {
                    this.form.id = null
                }
                checkAuthentication(this.$router, this.$route)
                  .then(() => {
                      saveItem('faq', JSON.stringify(this.form))
                        .then(() => {
                            this.$router.push({
                                name: 'DictionaryList',
                                params: { dictCode: this.dictCode, page: this.page },
                            })
                        })
                        .catch(error => {
                            reAuthenticate(this.$router, this.$route, error)
                        })
                  })
            },
            checkEditableNames: function (name) {
                const editableNames = ['valueId', 'value', 'order']
                return (editableNames.indexOf(name) >= 0)
            },
        },
        created () {
            if (this.$route.params.action === 'delete') {
                this.deleteItem()
            } else {
                this.getElementData()
            }
        },
    }
</script>


<style lang="scss" scoped type="text/scss">
	.dictionary-data .md-field {
		padding-top: 16px;
		margin: 4px 0 24px;
	}

	.offset-left-16 {
		margin-left: 16px;
	}
</style>
